/* global axios */
import ApiClient from './ApiClient';

const filterParams = filters => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v == null || v === '') return;
    if (Array.isArray(v)) v.forEach(x => p.append(`${k}[]`, x));
    else p.append(k, v);
  });
  return p;
};

class VoipLeadsAPI extends ApiClient {
  constructor() { super('voip_leads', { accountScoped: true }); }

  list(filters = {}, { page = 1, perPage = 25 } = {}) {
    const p = filterParams(filters);
    p.append('page', page); p.append('per_page', perPage);
    return axios.get(`${this.url}?${p.toString()}`);
  }
  // CSV pelo axios autenticado: link <a href> não manda os cabeçalhos de auth.
  exportCsv(filters = {}) {
    const query = filterParams(filters).toString();
    return axios.get(`${this.url}/export_csv${query ? `?${query}` : ''}`, {
      responseType: 'blob',
    });
  }
  counts() { return axios.get(`${this.url}/counts`); }
  show(id, { paginateCalls = false } = {}) {
    return axios.get(`${this.url}/${id}${paginateCalls ? '?paginate_calls=true' : ''}`);
  }
  score(id) { return axios.post(`${this.url}/${id}/score`); }
  listAppointments(id) { return axios.get(`${this.url}/${id}/appointments`); }
  createAppointment(id, payload) { return axios.post(`${this.url}/${id}/appointments`, payload); }
  updateAppointment(contactId, apptId, payload) {
    return axios.patch(`${this.url}/${contactId}/appointments/${apptId}`, payload);
  }
  // Phase 2.5 E — Coach AI
  getCoach(id) { return axios.get(`${this.url}/${id}/coach`); }
  generateCoach(id, { force = false } = {}) {
    return axios.post(`${this.url}/${id}/coach`, { force });
  }
}

export default new VoipLeadsAPI();
